(() => {
  const kill = () => document.querySelectorAll('#meteor-mobile-nav,#meteor-desktop-nav,.Meteor-MobileNavigation,.Meteor-Navigation,.tl-switcher-container').forEach(n => n.remove());
  kill(); new MutationObserver(kill).observe(document.documentElement, { childList:true, subtree:true });
  const $ = id => document.getElementById(id);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = matchMedia('(min-width: 961px) and (hover: hover)').matches;

  /* ---------- scrolling helper: Lenis when it is running, native otherwise ---------- */
  let lenis = null;
  const scrollTo = (target, opts) => {
    if (lenis) return lenis.scrollTo(target, Object.assign({ duration: 1.2 }, opts || {}));
    if (typeof target === 'number') return window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  /* ---------- header + fly-out menu ---------- */
  const top = $('efTop'), dim = $('dim'), fBtn = $('flyBtn'), burger = $('burger');
  let openTimer, closeTimer;
  const fly = $('fly');
  const st = document.createElement('style');
  st.textContent = '.fly{display:block!important;height:0;overflow:hidden;transition:height .5s cubic-bezier(.2,.7,.1,1)}@media (prefers-reduced-motion: reduce){.fly{transition:none}}';
  document.head.appendChild(st);
  function setOpen(on){
    fly.style.height = on ? Math.min(fly.firstElementChild.scrollHeight, innerHeight - 52) + 'px' : '0px';
    top.classList.toggle('open', on);
    dim.classList.toggle('on', on);
    fBtn.setAttribute('aria-expanded', on);
    burger.setAttribute('aria-expanded', on);
    fly.setAttribute('aria-hidden', !on);
    document.body.classList.toggle('menu-open', on && innerWidth <= 960);
  }
  const isOpen = () => top.classList.contains('open');
  fBtn.addEventListener('click', () => setOpen(!isOpen()));
  burger.addEventListener('click', () => setOpen(!isOpen()));
  dim.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen()){ setOpen(false); fBtn.focus(); } });
  if (matchMedia('(hover: hover)').matches){
    fBtn.addEventListener('mouseenter', () => { clearTimeout(closeTimer); openTimer = setTimeout(() => setOpen(true), 120); });
    fBtn.addEventListener('mouseleave', () => clearTimeout(openTimer));
    top.addEventListener('mouseleave', () => { clearTimeout(openTimer); closeTimer = setTimeout(() => setOpen(false), 220); });
    top.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  }
  document.querySelectorAll('#fly a').forEach(a => a.addEventListener('click', () => setOpen(false)));
  const pics = [...document.querySelectorAll('.fly-pic img')], cap = $('flyCap');
  document.querySelectorAll('.fly-main a[data-k]').forEach(a => {
    const show = () => {
      pics.forEach(p => p.classList.toggle('on', p.dataset.k === a.dataset.k));
      cap.textContent = a.dataset.cap || '';
    };
    a.addEventListener('mouseenter', show); a.addEventListener('focus', show);
  });

  /* in-page links (Shop, dock, header) go through the same scroller */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    a.addEventListener('click', e => { const el = $(id); if (el){ e.preventDefault(); if (isOpen()) setOpen(false); scrollTo(el); } });
  });

  /* ---------- progress line + section dots (built here so the Liquid stays clean) ---------- */
  const prog = document.createElement('div');
  prog.className = 'ef-prog'; prog.setAttribute('aria-hidden', 'true');
  document.body.appendChild(prog);

  const SECTIONS = [
    { id:'top',    key:'dots.fire',   label:'Fire' },
    { id:'choose', key:'dots.choose', label:'Fireplaces' },
    { id:'size',   key:'dots.size',   label:'Size' },
    { id:'homes',  key:'dots.homes',  label:'Homes' },
    { id:'visit',  key:'dots.visit',  label:'Visit' }
  ].filter(s => $(s.id));
  const dots = document.createElement('nav');
  dots.className = 'ef-dots'; dots.setAttribute('aria-label', 'Sections');
  dots.innerHTML = SECTIONS.map(s => '<a href="#' + s.id + '" data-sec="' + s.id + '"><span data-i18n="' + s.key + '">' + s.label + '</span><i></i></a>').join('');
  document.body.appendChild(dots);
  const dotLinks = [...dots.querySelectorAll('a')];
  dotLinks.forEach(a => a.addEventListener('click', e => { e.preventDefault(); const el = $(a.dataset.sec); el && scrollTo(el); }));

  /* ---------- video ---------- */
  const hv = $('heroVideo');
  hv.muted = true; hv.defaultMuted = true; hv.playsInline = true;
  hv.src = innerWidth < 900 ? hv.dataset.srcSm : hv.dataset.srcLg;
  const kick = () => { hv.muted = true; const p = hv.play(); p && p.catch(()=>{}); };
  kick();
  hv.addEventListener('loadeddata', kick, { once:true });
  ['touchstart','scroll','pointerdown'].forEach(ev => addEventListener(ev, () => { if (hv.paused) kick(); }, { once:true, passive:true }));
  const vio = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting){ if(!v.src && v.dataset.src){ v.muted = true; v.src = v.dataset.src; } v.play().catch(()=>{}); }
    else if (v.src) v.pause();
  }), { threshold: .2 });
  document.querySelectorAll('video.lazy').forEach(v => vio.observe(v));

  /* ---------- grid tiles: flame film on hover (desktop) / in view (touch) ---------- */
  (() => {
    const tiles = [...document.querySelectorAll('.tile')];
    if (!tiles.length) return;
    const light = (t, on) => {
      t.classList.toggle('lit', on);
      const v = t.querySelector('.tile-vid');
      if (!v) return;
      if (on){ if (!v.src && v.dataset.src){ v.muted = true; v.src = v.dataset.src; } v.play().catch(()=>{}); }
      else if (v.src) v.pause();
    };
    if (matchMedia('(hover: hover)').matches){
      tiles.forEach(t => {
        t.addEventListener('pointerenter', () => light(t, true));
        t.addEventListener('pointerleave', () => light(t, false));
        t.addEventListener('focusin', () => light(t, true));
        t.addEventListener('focusout', () => light(t, false));
      });
    } else {
      const io = new IntersectionObserver(es => es.forEach(e => light(e.target, e.isIntersecting)), { threshold: .6 });
      tiles.forEach(t => io.observe(t));
    }
  })();

  /* ---------- hero scroll nudge: once, only if the visitor hasn't moved ---------- */
  (() => {
    let moved = false;
    const mark = () => { moved = true; };
    ['wheel','touchstart','keydown','pointerdown'].forEach(ev => addEventListener(ev, mark, { passive:true, once:true }));
    let seen = false;
    try { seen = sessionStorage.getItem('ef-nudged') === '1'; } catch (e) {}
    if (reduce || seen) return;
    setTimeout(() => {
      if (moved || scrollY > 8) return;
      try { sessionStorage.setItem('ef-nudged', '1'); } catch (e) {}
      scrollTo(Math.round(innerHeight * .45), { duration: 1.6 });
    }, 2500);
  })();

  /* ---------- "say" words ---------- */
  const say = $('sayText');
  const T = k => (window.EF_T ? window.EF_T(k) : null);
  const sayStr = T('say') || say.textContent;
  say.innerHTML = sayStr.trim().split(/\s+/).map(w => {
    const hot = w.startsWith('{') && w.endsWith('}');
    return '<span class="w' + (hot ? ' hot' : '') + '">' + (hot ? w.slice(1, -1) : w) + '</span>';
  }).join(' ');

  /* ---------- sizer (inline + overlay share this) ---------- */
  const RL = [
    { name:'RL 450',  cover:40,  heat:6,  burn:'2–4',   price:35700, fuel:'fuel450',  vid:'47555338600749' },
    { name:'RL 600',  cover:55,  heat:7,  burn:'6–12',  price:43900, fuel:'fuel600',  vid:'47555338731821' },
    { name:'RL 900',  cover:70,  heat:8,  burn:'7–12',  price:51900, fuel:'fuel900',  vid:'47555338764589' },
    { name:'RL 1200', cover:110, heat:11, burn:'10–14', price:59500, fuel:'fuel1200', vid:'47555338797357' }
  ];
  const WA = '201273395883';
  const money = n => (window.EF_MONEY ? window.EF_MONEY(n) : 'EGP ' + n.toLocaleString('en-US'));
  const root = () => (window.EF_ROOT && window.EF_ROOT !== '/') ? window.EF_ROOT : '';
  function initSizer(box){
    const q = s => box.querySelector('[data-s="' + s + '"]');
    const area = q('area'); let last = '';
    function update(){
      const m2 = +area.value;
      area.style.setProperty('--p', ((m2-15)/(140-15)*100) + '%');
      q('areaOut').innerHTML = m2 + '<small>m²</small>';
      area.setAttribute('aria-valuetext', m2 + ' m²');
      let r = RL.find(x => x.cover >= m2), two = false;
      if (!r){ r = RL[3]; two = true; }
      const name = two ? '2 × RL 1200' : r.name;
      q('model').textContent = name;
      q('cover').textContent = (two ? r.cover*2 : r.cover) + ' m²';
      q('heat').textContent = (two ? r.heat*2 : r.heat) + ' kW';
      q('burn').textContent = r.burn + ' ' + (T('hrs') || 'hrs');
      q('price').textContent = money(two ? r.price*2 : r.price);
      q('fuel').textContent = T(two ? 'fuelTwo' : r.fuel) || '';
      const buy = q('buy'), wa = q('wa');
      buy.textContent = (T('size.buy') || 'Buy the {name}').replace('{name}', r.name);
      buy.href = root() + '/products/rl-manual?variant=' + r.vid;
      wa.textContent = T('size.wa') || 'Ask on WhatsApp';
      wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent((T('wa.msg') || "Hi EcoFire, I'm looking at the {name} for a {m2} m² room.").replace('{name}', name).replace('{m2}', m2));
      if (name !== last){ const a = q('answer'); a.classList.remove('bump'); void a.offsetWidth; a.classList.add('bump'); }
      last = name;
    }
    area.addEventListener('input', update);
    box._update = update;
    update();
  }
  const sizers = [...document.querySelectorAll('[data-sizer]')];
  sizers.forEach(initSizer);
  window.EF_SIZER_RERENDER = () => sizers.forEach(b => b._update && b._update());

  /* ---------- sizer overlay ---------- */
  const modal = $('sizerModal');
  let lastFocus = null;
  const modalOpen = () => modal && modal.classList.contains('on');
  function openSizer(e){
    if (!modal) return;
    lastFocus = e && e.currentTarget;
    if (isOpen()) setOpen(false);
    modal.classList.add('on');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sz-open');
    lenis && lenis.stop();
    const r = modal.querySelector('[data-s="area"]');
    setTimeout(() => r && r.focus({ preventScroll:true }), 350);
  }
  function closeSizer(){
    if (!modalOpen()) return;
    modal.classList.remove('on');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sz-open');
    lenis && lenis.start();
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll:true });
  }
  document.querySelectorAll('[data-open-sizer]').forEach(b => b.addEventListener('click', openSizer));
  document.querySelectorAll('[data-close-sizer]').forEach(b => b.addEventListener('click', closeSizer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && modalOpen()) closeSizer(); });
  if (modal) modal.querySelectorAll('a.btn').forEach(a => a.addEventListener('click', () => setTimeout(closeSizer, 150)));

  /* ---------- scroll-driven chrome: dock, progress line, active dot ---------- */
  const dock = $('dock');
  (() => {
    let t;
    const tick = () => {
      const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      prog.style.transform = 'scaleX(' + Math.min(1, scrollY / max).toFixed(4) + ')';
      const past = scrollY > 24;
      prog.classList.toggle('on', past);
      dots.classList.toggle('on', past);
      if (dock) dock.classList.toggle('on', scrollY > innerHeight * .55);
      const line = scrollY + innerHeight * .45;
      let cur = SECTIONS[0] && SECTIONS[0].id;
      SECTIONS.forEach(s => { const el = $(s.id); if (el && el.getBoundingClientRect().top + scrollY <= line) cur = s.id; });
      if (scrollY + innerHeight >= document.documentElement.scrollHeight - 40) cur = SECTIONS[SECTIONS.length - 1].id;
      dotLinks.forEach(a => { const on = a.dataset.sec === cur; a.classList.toggle('on', on); on ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current'); });
    };
    addEventListener('scroll', () => { if (!t) t = requestAnimationFrame(() => { tick(); t = 0; }); }, { passive:true });
    addEventListener('resize', tick, { passive:true });
    tick();
  })();

  /* ---------- scroll motion: only the hero pins; everything else flows ---------- */
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  /* Lenis: weighted, inertial wheel scrolling on desktop. Phones keep native scrolling. */
  if (desktop && !reduce){
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.min.js';
    s.onload = () => {
      if (!window.Lenis) return;
      lenis = new Lenis({ lerp: .09, wheelMultiplier: 1, smoothWheel: true, syncTouch: false });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(t => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
      if (modalOpen()) lenis.stop();
    };
    document.head.appendChild(s);
  }

  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    gsap.timeline({ scrollTrigger:{ trigger:'.hero', start:'top top', end:'+=95%', pin:true, scrub:.8, anticipatePin:1 } })
      .to('#scrollHint', { opacity:0, duration:.1 }, 0)
      .to('#heroTitle', { y:-110, opacity:0, ease:'power2.in', duration:.45 }, 0)
      .fromTo('#heroMedia', { clipPath:'inset(0% 0% 0% 0% round 0px)' }, { clipPath:'inset(13% 8% 17% 8% round 32px)', ease:'power2.inOut', duration:.8 }, .12)
      .fromTo('#heroMedia video', { scale:1.12 }, { scale:1, ease:'none', duration:.95 }, 0)
      .to('#heroMedia .wash', { opacity:.25, duration:.6 }, .2)
      .fromTo('#heroAfter', { opacity:0, y:24 }, { opacity:1, y:0, duration:.3 }, .68);

    gsap.to('#sayText .w', { opacity:1, stagger:.06, ease:'none',
      scrollTrigger:{ trigger:'.say', start:'top 85%', end:'bottom 55%', scrub:.4 } });

    gsap.fromTo('#wallFrame', { scale:.9 }, { scale:1, ease:'none',
      scrollTrigger:{ trigger:'#wallFrame', start:'top bottom', end:'center center', scrub:true } });

    gsap.utils.toArray('.choose-head > *, .reel-head > *, .promises > div, .sizer .sizer-box, .visit h2, .visit .lede, .room, .visit .cta').forEach(el => {
      gsap.from(el, { y:36, opacity:0, duration:.9, ease:'power3.out', scrollTrigger:{ trigger:el, start:'top 90%', once:true } });
    });
    const tiles = gsap.utils.toArray('.tile');
    if (tiles.length) gsap.from(tiles, { y:40, opacity:0, duration:.9, ease:'power3.out', stagger:.07,
      scrollTrigger:{ trigger:'.grid', start:'top 85%', once:true } });
    const slides = gsap.utils.toArray('.slide');
    if (slides.length) gsap.from(slides, { y:40, opacity:0, duration:.9, ease:'power3.out', stagger:.1,
      scrollTrigger:{ trigger:'.reel-pin', start:'top 85%', once:true } });
  });
  addEventListener('load', () => ScrollTrigger.refresh());
})();
